<template>
  <section>
    <v-card>
      <v-card-title class="chart-title" primary-title>
        School Registration
      </v-card-title>

      <v-card-actions>
        <v-select
          :items="dropDown"
          label="View By"
          class="mainGraphSelect pl-3 pt-4"
          return-object
          v-model="dropDownSelection"
        ></v-select>
        <report-date-picker
          class="mx-3"
          :prop-date-from="dateFrom"
          :prop-date-to="dateTo"
          @dateToSelected="dateToSelected"
          @dateFromSelected="dateFromSelected"
        />
      </v-card-actions>

      <v-tabs v-model="tab" icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab key="chart">
          Chart
          <v-icon>pie_chart</v-icon>
        </v-tab>

        <v-tab key="table">
          Table
          <v-icon>table_chart</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="chart" class="pa-4">
          <pie-chart
            v-if="chartData"
            ref="chart"
            :chart-data="chartData"
            :options="options"
          />
          <div v-else>
            No Data Available
          </div>
        </v-tab-item>
        <v-tab-item key="table" class="pa-4">
          <card-table
            v-if="tableData"
            :headers="tableData.headers"
            :items="tableData.items"
          />
          <div v-else>
            No Data Available
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
import ReportDatePicker from '@/modules/client/views/reports/ReportDatePicker'
import ReportsMixin from '@/modules/client/views/reports/reports-mixin'
import PieChart from '../charts/PieChart'
import CardTable from '@/modules/client/views/dashboard/CardTable'

export default {
  components: {
    ReportDatePicker,
    PieChart,
    CardTable
  },
  mixins: [ReportsMixin],
  created() {
    // this.dateFrom = this.$moment()
    //   .startOf('year')
    //   .format('YYYY-MM-DD')
  },
  async mounted() {
    this.type = this.dropDownSelection.value
    await this.searchItems()
  },
  data() {
    return {
      tab: null,
      dropDown: [
        { text: 'School Sector', value: 'schoolsBySector' },
        { text: 'School Type', value: 'schoolsByType' },
        { text: 'School Gender', value: 'schoolsByGender' },
        { text: 'School State', value: 'schoolsByState' }
      ],
      dropDownSelection: { text: 'School Sector', value: 'schoolsBySector' },
      options: {
        animation: {
          duration: 500,
          easing: 'easeInOutSine'
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMin: 0
              }
            }
          ]
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      items: {}
    }
  },
  watch: {
    async dropDownSelection(value) {
      this.type = value.value
      await this.searchItems()
    }
  },
  computed: {
    chartData() {
      if (!this.items) return null
      if (Object.keys(this.items).length === 0) return null
      return {
        labels: this.items.labels ? this.items.labels : [],
        datasets: [
          {
            data: this.items.data ? this.items.data : [],
            backgroundColor: [
              '#900048',
              '#099A97',
              '#9764C7',
              '#faaf3a',
              '#fa3c2a',
              '#9764C7',
              '#900048',
              '#099A97',
              '#9764C7',
              '#900048',
              '#099A97',
              '#9764C7',
              '#099A97',
              '#9764C7',
              '#099A97',
              '#9764C7'
            ]
          }
        ]
      }
    },
    tableHeaders() {
      if (!this.items) return []
      if (!this.items.labels) return []
      return [
        {
          text: this.dropDownSelection.text,
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Number',
          align: 'right',
          sortable: true,
          value: 'count'
        }
      ]
    },
    tableItems() {
      if (!this.items) return []
      if (!this.items.data) return []
      let list = []
      for (let i = 0; i < this.items.data.length; i++) {
        list.push({
          name: this.items.labels[i],
          count: this.items.data[i]
        })
      }
      return list
    },
    tableData() {
      if (!this.items) return null
      if (Object.keys(this.items).length === 0) return null
      return {
        headers: this.tableHeaders,
        items: this.tableItems
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
